/**
 * Textos (es) de planta — OBR-148: proposta de lot FEFO i escaneig de l'etiqueta: namespace `planta.fefo`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts) i les mateixes
 * variables. Vocabulari del sector: «Existències», mai «Stock».
 */

export const fefoEs = {
  'planta.fefo': {
    // ── Lote propuesto (pesaje de OT y preparación de pedidos) ───────────────────────────────
    suggestedChip: 'Sugerido (FEFO)',
    scannedChip: 'Escaneado',
    splitHint:
      'La cantidad se reparte entre varios lotes, por orden de caducidad. Lo puedes cambiar.',
    heldByOpenOrders: 'Ya pesado en otras OT abiertas: {{quantity}}',
    overdraw:
      'En el lote {{lot}} solo hay {{available}}: sobran {{over}}. Puedes repartirlo con otro lote o dejarlo así.',

    // ── Escaneo de la etiqueta de un lote ──────────────────────────────────────────────────
    scanButton: 'Escanea un lote',
    scanPickingTitle: 'Escanea la etiqueta del lote',
    scanPickingHint: 'Apunta la cámara al código QR del lote que vas a servir',
    scanAccepted: 'Lote {{lot}} escaneado y elegido.',
    scanNoStock:
      'El lote {{lot}} no tiene existencias en el dispositivo. Se elige igualmente porque lo has escaneado.',
    scanNoStockPicking:
      'El lote {{lot}} no tiene existencias en el dispositivo: no se ha podido poner. Se propone el resto por orden de caducidad.',
    scanNotOffered:
      'El lote {{lot}} no consta entre los lotes de esta línea en el dispositivo, así que no se ha elegido. Vuelve a probar cuando se haya sincronizado.',
    scanUnknown: 'Este código no es ningún lote que el dispositivo conozca.',
    scanWrongArticle:
      'El lote {{lot}} es de «{{article}}», no de «{{expected}}». No se puede usar aquí.',
    scanWrongArticleUnnamed:
      'El lote {{lot}} es de otro artículo, no de «{{expected}}». No se puede usar aquí.',
    scanWrongArticleGeneric:
      'El lote {{lot}} es de «{{article}}», no del artículo que preparas. No se puede usar aquí.',
    scanWrongArticleGenericUnnamed:
      'El lote {{lot}} es de otro artículo, no del que preparas. No se puede usar aquí.',
    cascadeHint: 'El lote elegido no tiene suficiente: el resto sale de otros lotes, por orden de caducidad.',
  },
} as const;
